export default __webpack_public_path__ + "static/media/doc.cbfc5de8.png";